export enum NOTIFICATION_TYPE_VIEW {
  STORYBOX = 'storybox',
  GLOBALHUB = 'globalhub'
}
